// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2Ljk7","clinicsSelect":"TableHeading_clinicsSelect__1AN2J"};